"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const sulu_1 = require("../../../api/sulu");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const configuration_1 = require("../../apis/configuration/sulu/configuration");
const resources_1 = require("../../helper/resources");
const ResellerFileExplorer_1 = __importDefault(require("../reseller/ResellerFileExplorer"));
const ResellerAreaContentPage = ({ route }) => {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [resellerPage, setResellerPage] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const api = new sulu_1.ResellerApi(configuration_1.authenticatedConfiguration);
        const resellerNavigationItem = route?.resellerNavigationItem;
        if (!resellerNavigationItem) {
            throw new Error('Invalid navigation configuration');
        }
        setLoading(true);
        api.getResellerPage({
            pathname: resellerNavigationItem.pathname,
            locale: resellerNavigationItem.locale,
        })
            .then(setResellerPage)
            .finally(() => setLoading(false));
    }, [route?.resellerNavigationItem]);
    (0, react_1.useEffect)(() => {
        document.title = (0, translation_1.t)('reseller_subpage_title', { title: resellerPage?.title ?? '' });
    }, [resellerPage?.title ?? '']);
    (0, react_1.useEffect)(() => {
        if (!resellerPage?.content) {
            return;
        }
        let scriptElements = [];
        resellerPage?.content?.map((page) => {
            if (page?.type === 'script_editor') {
                setTimeout(() => {
                    const div = document.createElement('div');
                    div.innerHTML = page?.content ?? '';
                    const scripts = div.getElementsByTagName('script');
                    scriptElements = (0, resources_1.addScriptContentsToDom)(Array.from(scripts));
                }, 0);
            }
        });
        return () => {
            scriptElements.forEach((scriptElement) => {
                scriptElement.remove();
            });
        };
    }, [route?.resellerNavigationItem, resellerPage?.content]);
    if (loading) {
        return (react_1.default.createElement("div", { className: "position-relative mt-5 " },
            react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
    }
    return (react_1.default.createElement("section", null, resellerPage?.content?.map((page, index) => {
        switch (page?.type) {
            case 'file_explorer':
                return react_1.default.createElement(ResellerFileExplorer_1.default, { relativePath: page?.content, key: index });
            case 'script_editor':
                return null;
            default:
                return (react_1.default.createElement("div", { key: index, className: "znd-reseller-page__content", dangerouslySetInnerHTML: { __html: page?.content ?? '' } }));
        }
    })));
};
exports.default = ResellerAreaContentPage;
